<template>
  <v-flex xs12 sm6 d-flex>
    <v-select :items="partners" label="Tipo de Parceiro" v-model="partner"
              item-text="title" item-value="business" return-object prepend-icon="work_outline"></v-select>
  </v-flex>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import * as business from '@/helpers/business';

export default {
  name: 'Partner',
  computed: {
    partner: {
      get() {
        return this.model;
      },
      set(newPartner) {
        this.$store.dispatch('payments/setPartner', newPartner);
        this.model;
      },
    },
    ...mapGetters({
      model: 'payments/filtersPartner',
    }),
  },
  data: () => ({
    partners: [
      { title:  'Todos', business: '' },
      { title:  'Master', business: business.PARTNER_MASTER },
      { title:  'Executive', business: business.PARTNER_EXECUTIVE },
      { title:  'Estabelecimento', business: business.PARTNER_ESTABLISHMENT },
    ],

  }),
};
</script>
